module.exports = __webpack_public_path__ + "static/media/xlsx.3e509faf.svg";